import { Card, CardContent, List, Stack, Typography } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";

import { passwordSchemaRules } from "../../schemas/password";

import { RuleListItem } from "./rule-list-item";

export interface PasswordRuleProps {
	readonly password: string;
}

export const PasswordRules: React.FC<PasswordRuleProps> = ({ password }: PasswordRuleProps) => {
	const intl = useIntl();
	const rules = passwordSchemaRules(intl);

	const ruleItems = [
		{
			key: "minLength",
			fulfilled: rules.minLength.safeParse(password).success,
			message: <FormattedMessage id="password-rules.minLength" defaultMessage="Minimum length of 8" />,
		},
		{
			key: "hasLowercase",
			fulfilled: rules.hasLowercase.safeParse(password).success,
			message: <FormattedMessage id="password-rules.hasLowercase" defaultMessage="Must contain lowercase characters" />,
		},
		{
			key: "hasUppercase",
			fulfilled: rules.hasUppercase.safeParse(password).success,
			message: <FormattedMessage id="password-rules.hasUppercase" defaultMessage="Must contain uppercase characters" />,
		},
		{
			key: "hasNumber",
			fulfilled: rules.hasNumber.safeParse(password).success,
			message: <FormattedMessage id="password-rules.hasNumber" defaultMessage="Must contain numbers" />,
		},
		{
			key: "hasSymbol",
			fulfilled: rules.hasSymbol.safeParse(password).success,
			message: <FormattedMessage id="password-rules.hasSymbol" defaultMessage="Must contain symbols" />,
		},
	];

	return (
		<Card data-testid="password-rules">
			<CardContent>
				<Stack gap={1}>
					<Typography variant="body2" data-testid="password-rules__text__title">
						<FormattedMessage id="password-rules.title" defaultMessage="Password Rules:" />
					</Typography>

					<List disablePadding>
						{ruleItems.map((item) => (
							<RuleListItem
								key={item.key}
								testId={`password-rules__text__rule-${item.key}`}
								message={item.message}
								criteriaMet={item.fulfilled}
							/>
						))}
					</List>
				</Stack>
			</CardContent>
		</Card>
	);
};
